/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerMongoDBSourceComponent', [
    '$rootScope',
    'DesignerDatabaseBaseSourceComponent',
    'DesignerConnection',

    function ($rootScope, DesignerDatabaseBaseSourceComponent, DesignerConnection) {
      function DesignerMongoDBSourceComponent() {
        DesignerDatabaseBaseSourceComponent.apply(this);
      }

      DesignerMongoDBSourceComponent.prototype = new DesignerDatabaseBaseSourceComponent();

      DesignerMongoDBSourceComponent.prototype.getData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getData.call(this);

        _.extend(data, {
          where_clause: this.where_clause || this.defaults.where_clause,
        });

        return data;
      };

      DesignerMongoDBSourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerDatabaseBaseSourceComponent.prototype.setFormData.call(this, data);
      };

      DesignerMongoDBSourceComponent.prototype.setData = function (data) {
        this.where_clause = data.where_clause;

        DesignerDatabaseBaseSourceComponent.prototype.setData.call(this, data);
      };

      return DesignerMongoDBSourceComponent;
    },
  ]);
})(window.angular);
